import { isNodeJS } from '../../compat';
import { avp } from "@adsk/lmv";

let { ProgressBar } = avp;
if (isNodeJS()) {
	// avp.ProgressBar is undefined in node builds.
	ProgressBar = Object;
}

export class DtProgressBar extends ProgressBar {
	shiftProgressBar(amount) {
		this.bg.style.left = amount ? `${amount}px` : null;
	}
}
